module.exports = __webpack_public_path__ + "assets/img/1430.8cabe0c9.svg";